import { createContext, type ReactNode, useContext, useMemo } from 'react';
import { InteractionType } from '@/common/types/interaction';
import type { CoverSheetConfig } from '../configurations/types';

interface CoverSheetContextInterface {
  interactionId: string; // URL id
  interactionType: InteractionType;
  config?: CoverSheetConfig;
}

const CoverSheetContext = createContext<CoverSheetContextInterface>({
  interactionId: '',
  interactionType: InteractionType.listing,
  config: undefined,
});

export function useCoverSheetContext() {
  return useContext(CoverSheetContext);
}

interface Props {
  interactionId: string;
  interactionType: InteractionType;
  config?: CoverSheetConfig;
  children: ReactNode;
}

export const CoverSheetProvider = ({
  interactionId,
  interactionType,
  config,
  children,
}: Props) => {
  const contextValue = useMemo<CoverSheetContextInterface>(
    () => ({
      interactionId,
      interactionType,
      config,
    }),
    [interactionId, interactionType, config],
  );

  return (
    <CoverSheetContext.Provider value={contextValue}>
      {children}
    </CoverSheetContext.Provider>
  );
};
